export default __webpack_public_path__ + "media/images/email-icon-ca70407cbcbd7c30aa289f5acf4665e7.svg";